import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface UserItem {
    accessToken: string;
    m_email: string;
    m_level: number | null;
    m_name: string;
}

interface AuthStore {
    accessToken: string;
    m_email: string;
    m_level: number | null;
    m_name: string;
    setUser: (data: UserItem) => void;
    clearUser: () => void;
}

export const useAuthStore = create<AuthStore>()(
    persist(
        set => ({
            accessToken: "",
            m_email: "",
            m_level: null,
            m_name: "",

            setUser: (data: UserItem) =>
                set({
                    accessToken: data.accessToken, // 암호화하여 저장
                    m_email: data.m_email,
                    m_level: data.m_level,
                    m_name: data.m_name,
                }),
            // setUser: (data: UserItem) => set((state) => ({
            //     ...state,
            //     ...data,
            // })),

            clearUser: () =>
                set({
                    accessToken: "",
                    m_email: "",
                    m_level: null,
                    m_name: "",
                }),
        }),
        {
            name: "auth-storage", // localStorage에 저장될 키 이름
            storage: createJSONStorage(() => localStorage),
        },
    ),
);
